import { render, staticRenderFns } from "./audio.module.vue?vue&type=template&id=4755ed0d&scoped=true"
import script from "./audio.module.vue?vue&type=script&lang=js"
export * from "./audio.module.vue?vue&type=script&lang=js"
import style0 from "./audio.module.vue?vue&type=style&index=0&id=4755ed0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755ed0d",
  null
  
)

export default component.exports